import { normalizeSectionId } from './section-ids';
import type { SectionBestPrice, TicketGroupPrice } from './types';

export function getBestSectionPrices(
  ticketGroups: readonly TicketGroupPrice[],
  selectedSectionIds: readonly string[] = []
): SectionBestPrice[] {
  const pricesBySection = new Map<string, SectionBestPrice>();
  const selectedIds = new Set(
    selectedSectionIds.map((sectionId) => normalizeSectionId(sectionId))
  );

  ticketGroups.forEach(
    ({ tevo_section_name, retail_price, available_quantity, featured }) => {
      const sectionName = tevo_section_name.trim();
      const sectionId = normalizeSectionId(sectionName);

      if (
        !sectionId ||
        !Number.isFinite(retail_price) ||
        (selectedIds.size > 0 && !selectedIds.has(sectionId))
      ) {
        return;
      }

      const current = pricesBySection.get(sectionId);
      if (!current || retail_price < current.price) {
        pricesBySection.set(sectionId, {
          sectionId,
          sectionName: current?.sectionName ?? sectionName,
          price: retail_price,
          ...(available_quantity !== undefined
            ? { availableQuantity: available_quantity }
            : {}),
          ...(featured !== undefined ? { isFeatured: featured } : {}),
        });
        return;
      }

      if (retail_price === current.price) {
        pricesBySection.set(sectionId, {
          sectionId,
          sectionName: current.sectionName,
          price: current.price,
        });
      }
    }
  );

  return [...pricesBySection.values()].sort(
    (left, right) =>
      left.price - right.price ||
      left.sectionName.localeCompare(right.sectionName)
  );
}
